import { render, staticRenderFns } from "./UploadStartups.vue?vue&type=template&id=810cf802"
import script from "./UploadStartups.vue?vue&type=script&lang=js"
export * from "./UploadStartups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports